import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

function loadGoogleTagManager(): void {
	const tgmId = environment.googleTagManagerId;

	if (!tgmId) {
		return;
	}

	const windowRef = window as typeof window & {
		dataLayer?: Record<string, unknown>[];
	};

	windowRef.dataLayer ??= [];
	windowRef.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

	const firstScript = document.getElementsByTagName("script")[0];
	const script = document.createElement("script");

	script.async = true;
	script.src = `https://www.googletagmanager.com/gtm.js?id=${tgmId}`;

	firstScript.parentNode.insertBefore(script, firstScript);
}

if (environment.production) {
	enableProdMode();
}

loadGoogleTagManager();

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
